/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { homepageReducer as rootReducer } from './reducers/index'

export default filterActions(rootReducer, Object.values(constants))
